import { useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useAtomValue } from 'jotai';
import { ReactElement } from 'react';

import Layout from '@/components/layout/Layout';
import { useSimpleAuthDialog } from '@/components/tax-refund/simple-auth/confirm/Dialogs';
import { SimpleAuthConfirmContainer } from '@/components/tax-refund/simple-auth/confirm/SimpleAuthConfirmContainer';
import { useExitService } from '@/lib/hooks/use-exit-service';
import { useFromTypeStaticData } from '@/lib/hooks/use-simple-auth-from-type';
import { simpleAuthCertTypeAtom, simpleAuthFromTypeAtom } from '@/lib/stores/simple-auth';

const SimpleAuthConfirmPage = () => {
  const fromType = useAtomValue(simpleAuthFromTypeAtom);
  const certType = useAtomValue(simpleAuthCertTypeAtom);
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();
  const { hasExitButton, getConfirmPageEvents } = useFromTypeStaticData(fromType);
  const { showDialogExitConfirm } = useSimpleAuthDialog();
  const { exitService } = useExitService();

  const events = getConfirmPageEvents();

  sendViewEvent(events.view, { type: certType });

  return (
    <Layout
      className={'flex-1 flex flex-col'}
      mainClassName={'flex-1 flex flex-col w-full'}
      rightTextButton={
        hasExitButton
          ? {
              label: '나가기',
              state: 'gray',
              onClick: () => {
                sendClickEvent(events.clickExit, { type: certType });
                showDialogExitConfirm({
                  onClickPrimary: () => {
                    exitService();
                  }
                });
              }
            }
          : undefined
      }
    >
      <SimpleAuthConfirmContainer />
    </Layout>
  );
};

SimpleAuthConfirmPage.getLayout = (page: ReactElement) => <AuthGuard>{page}</AuthGuard>;

export default SimpleAuthConfirmPage;
